import { createMuiTheme } from '@material-ui/core/styles';

export const palette = {
    primary: { main: '#fd6144' },
    secondary: { main: '#26C6DA' }
};
const themeName = "Outrageous Orange Scooter Geoffroy's Cat";

export default createMuiTheme({ palette, themeName });
